var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefits3Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7167 5.93333C28.9333 3.61667 25.4833 2.1 21.6667 1.75V5.1C24.55 5.41667 27.1833 6.56667 29.35 8.3L31.7167 5.93333ZM18.3333 5.1V1.75C14.5167 2.08333 11.0667 3.61667 8.28333 5.93333L10.65 8.3C12.8547 6.52435 15.52 5.41427 18.3333 5.1ZM8.3 10.65L5.93333 8.28333C3.61667 11.0667 2.1 14.5167 1.75 18.3333H5.1C5.41667 15.45 6.56667 12.8167 8.3 10.65ZM34.9 18.3333H38.25C37.9 14.5167 36.3833 11.0667 34.0667 8.28333L31.7 10.65C33.4757 12.8547 34.5857 15.52 34.9 18.3333Z",
    fill: "#FFAC90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 35.0002C17.539 34.9997 15.1159 34.3908 12.9468 33.2277C10.7776 32.0646 8.92952 30.3833 7.56699 28.3335H11.667V25.0002H1.66699V35.0002H5.00033V30.5002C8.31699 35.2335 13.7837 38.3335 20.0003 38.3335C28.117 38.3335 35.0003 33.0502 37.4003 25.7335L34.1337 24.9835C32.0837 30.8002 26.5337 35.0002 20.0003 35.0002Z",
    fill: "#FFAC90"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_544_1175)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.2285,
    y: 13.0408,
    width: 8.16327,
    height: 12.7551,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0649 19.5714C28.0649 23.9107 24.547 27.4285 20.2077 27.4285C15.8684 27.4285 12.3506 23.9107 12.3506 19.5714C12.3506 15.2321 15.8684 11.7142 20.2077 11.7142C24.547 11.7142 28.0649 15.2321 28.0649 19.5714ZM23.9863 18.4999H20.922V14.1635L16.4292 20.6428H19.4934V24.9792L23.9863 18.4999Z",
    fill: "#FC6430"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_544_1175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.1429,
    height: 17.1429,
    fill: "white",
    transform: "translate(11.6367 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefits3Icon);
export default __webpack_public_path__ + "static/media/benefits3 icon.ed008591236ad80cade4dba57e8c3601.svg";
export { ForwardRef as ReactComponent };